import {API_URL} from "./constants";

export function getInitialData(apiToken) {
    /* Fetch shared resources simultaneously */
    let urls = [
        API_URL + "/session-types",
        API_URL + "/sessions",
        API_URL + '/sessions?only_unassigned=1&include_papers=0'
    ];

    // map every url to the promise of the fetch
    let requests = urls.map(url => fetch(url,{
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + apiToken,
            'Accept': 'application/json',
        },
    }));

    // Promise.all waits until all jobs are resolved
    return Promise.all(requests)
        .then(responses => {
            // all responses are resolved successfully
            for (let response of responses) {
                if (!response.ok) throw Error(response.statusText);    // Will go to .catch
            }
            return responses;
        })
        // map array of responses into an array of response.json() to read their content
        .then(responses => Promise.all(responses.map(r => r.json())))
        // all JSON answers are parsed: "results" is the array of them
        .then(results => {
            return results;
        })
}

/**
 * Performs a HTTP DELETE request on session resource.
 * @param sessionId
 * @param apiToken
 * @param callback
 */
export function deleteSession(sessionId, apiToken, callback) {
    fetch(API_URL + '/sessions/' + sessionId, {
        method: 'DELETE',
        headers: {'Authorization': 'Bearer ' + apiToken}
    }).then((response) => {
        if (!response.ok) throw Error(response.statusText);    // Will go to .catch

        /* If session has been deleted correctly from the server side
        then remove it from the session list by calling the callback */
        callback()
    }).catch((error) => {
        alert(error);
    });
}

/**
 * Performs a HTTP GET to login the user
 */
export function getLogin(formData) {
    const body = {
        'email': formData.email,
        'password': formData.password
    };

    return fetch(API_URL + '/auth/login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify(body),
    }).then((response) => {
        if (!response.ok) throw Error("Wrong credentials");
        return response.json();
    })
}

/**
 * Performs a HTTP GET request to logout the user
 * @param apiToken
 * @param callback
 */
export function getLogout(apiToken, callback) {
    fetch(API_URL + '/auth/logout', {
        method: 'GET',
        headers: {'Authorization': 'Bearer ' + apiToken}
    }).then((response) => {
        if (!response.ok) throw Error(response.statusText);    // Will go to .catch
        callback()
    }).catch((error) => {
        alert(error);
    });
}

/**
 * Performs a HTTP POST request to send password reset link
 * @param formData
 */
export function postPasswordResetLink(formData) {
    const body = {
        'email': formData.email
    };

    return fetch(API_URL + '/password/reset-link', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify(body),
    }).then((response) => {
        if (!response.ok) throw Error(response.statusText);
        return response.json();
    })
}

/**
 * Performs a HTTP GET request to import papers
 * @param apiToken
 * @param callback
 */
export function getImportPapers(apiToken, callback) {
    fetch(API_URL + '/admin/import-papers', {
        method: 'GET',
        headers: {'Authorization': 'Bearer ' + apiToken}
    }).then((response) => {
        if (!response.ok) throw Error(response.statusText);    // Will go to .catch
        return response.json();
    }).then((data) => {
        callback(data);
    }).catch((error) => {
        alert(error);
    });
}

/**
 * Performs a HTTP GET request to publish Overview and Preview html files
 * @param apiToken
 * @param callback
 */
export function getPublish(apiToken, callback) {
    fetch(API_URL + "/admin/publish", {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + apiToken,
            'Accept': 'application/json',
        },
    })
        .then(response => {
            if (!response.ok) throw Error(response.statusText);    // Will go to .catch
            return response.json();
        })
        .then(
            (result) => {
                callback(result);
            })
        .catch((error) => {
            alert(error);
        });
}

/**
 * Performs a HTTP GET request to get the unassigned papers.
 * @param apiToken
 * @param callback
 */
export function getUnassignedPapers(apiToken, callback) {
    fetch(API_URL + "/papers?only_unassigned=1", {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + apiToken,
            'Accept': 'application/json',
        },
    })
        .then(response => {
            if (!response.ok) throw Error(response.statusText);    // Will go to .catch
            return response.json();
        })
        .then(
            (result) => {
                callback(result);
            })
        .catch((error) => {
            alert(error);
        });
}

/**
 * Performs a HTTP POST request to create a new activity.
 * @param data
 * @param apiToken
 * @param callback
 */
export function postActivityLog(data, apiToken, callback = () => {}) {
    fetch(API_URL + "/activity-log", {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + apiToken,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data),
    }).then((response) => {
        if (!response.ok) throw Error(response.statusText);    // Will go to .catch
        return response.json();
    }).then((result) => {
        callback(result);
    }).catch((error) => {
        alert(error);
    })
}

/**
 * Performs a HTTP GET request to import papers
 * @param type
 * @param apiToken
 * @param callback
 */
export function getActivityLogs(type, apiToken, callback = () => {}) {
    fetch(API_URL + '/activity-log?type=' + type, {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + apiToken,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }).then((response) => {
        if (!response.ok) throw Error(response.statusText);    // Will go to .catch
        return response.json();
    }).then((data) => {
        callback(data);
    }).catch((error) => {
        alert(error);
    });
}

/**
 * Performs a HTTP GET request to import papers
 * @param activityId
 * @param apiToken
 * @param callback
 */
export function getActivityLogRestore(activityId, apiToken, callback = () => {}) {
    fetch(API_URL + '/activity-log/' + activityId + '/restore', {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + apiToken,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }).then((response) => {
        if (!response.ok) throw Error(response.statusText);    // Will go to .catch
        return response.json();
    }).then((data) => {
        callback(data);
    }).catch((error) => {
        alert(error);
    });
}
